import ServerTableController from "./server_table_base"

export default class extends ServerTableController {
  get filterWrapperName() { return "appreciations-filter" }
  get checkboxPrefix() { return "appreciations" }

  // Rows are rendered server-side (appreciations/_appreciation_row): [sort_date, html].
  get columns() {
    return [
      { data: "0", visible: false },
      { data: "1" }
    ]
  }

  createdRow(row, data, _dataIndex) {
    $(row).addClass("item").html(data[1])
  }
}
